import { render, staticRenderFns } from "./ResumenVentasFilters.vue?vue&type=template&id=5977aaa4"
import script from "./ResumenVentasFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./ResumenVentasFilters.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports